import * as t from "io-ts";
import nullable from "./nullable";
import { withFallback } from "io-ts-types";
const attachmentT = t.strict({
    url: t.string,
    urlNew: t.string,
    pdfUrl: t.string,
});
export const errProductBarredT = t.strict({
    type: t.literal("PRODUCT_BARRED"),
    productNumber: t.string,
});
export const errCustomerBarredT = t.strict({
    type: t.literal("CUSTOMER_BARRED"),
    customerNumber: t.string,
});
export const errCustomerDeletedT = t.strict({
    type: t.literal("CUSTOMER_DELETED"),
    customerNumber: t.string,
});
export const errDeliveryLocationDeletedT = t.strict({
    type: t.literal("DELIVERY_LOCATION_DELETED"),
    deliveryLocationNumber: t.string,
});
export const sendErrorReasonT = t.union([
    errProductBarredT,
    errCustomerBarredT,
    errCustomerDeletedT,
    errDeliveryLocationDeletedT,
]);
export const resendInvoiceChangeT = t.union([
    t.strict({
        type: t.literal("PRODUCT_BARRED"),
        oldProductNumber: t.string,
        newProductNumber: t.string,
    }),
    t.strict({
        type: t.literal("CUSTOMER_BARRED"),
        oldCustomerNumber: t.string,
        newCustomerNumber: t.string,
    }),
    t.strict({
        type: t.literal("CUSTOMER_DELETED"),
        oldCustomerNumber: t.string,
        newCustomerNumber: t.string,
    }),
    t.strict({
        type: t.literal("DELIVERY_LOCATION_DELETED"),
    }),
]);
export const resendInvoiceWithChangesReqT = t.strict({
    changes: t.array(resendInvoiceChangeT),
});
export const createOutgoingInvoiceTypes = ({ decimal, }) => {
    const outgoingInvoiceLineT = t.strict({
        productId: t.string,
        description: nullable(t.string),
        quantity: decimal,
        unitNetPrice: decimal,
        departmentId: nullable(t.string),
        discountPercentage: withFallback(nullable(decimal), null),
    });
    const outgoingInvoiceT = t.strict({
        id: t.string,
        orgId: t.string,
        clientId: t.string,
        customerContactId: nullable(t.string),
        date: t.string,
        attachments: t.array(attachmentT),
        otherRef: nullable(t.string),
        status: t.union([
            t.literal("INVOICE_CREATED"),
            t.literal("INVOICE_SENT"),
            t.literal("INVOICE_FAILED"),
        ]),
        lines: t.array(outgoingInvoiceLineT),
    });
    const failedOutgoingInvoiceT = t.strict({
        id: t.string,
        clientId: t.string,
        date: t.string,
        otherRef: nullable(t.string),
        total: decimal,
        sentToEconomic: t.boolean,
        sendErrorReason: withFallback(nullable(t.array(sendErrorReasonT)), null),
    });
    const failedOutgoingInvoicesT = t.array(failedOutgoingInvoiceT);
    return {
        outgoingInvoiceT,
        outgoingInvoiceLineT,
        failedOutgoingInvoiceT,
        failedOutgoingInvoicesT,
    };
};
//# sourceMappingURL=outgoing-invoice.js.map